<template>
<div>
    <Breadcrumbs main="Location" submain="Route" title="Route List" />

    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add New Route</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="items" :fields="tablefields" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteItem(data.item.id)" title="Delete"></feather>
                                            <feather @click="editItem(data.item)" type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <div class="loader-box">
                                <div class="loader-10"></div>
                            </div>
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Create Item -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Create New Route" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit">
            <b-form-group label="Route Name" label-for="name-input" invalid-feedback="Item is required">
                <b-form-input id="name-input" v-model="item.name" placeholder="Enter Route Name"></b-form-input>
            </b-form-group>

            <div class="form-group">
                <label>Territory</label>
                <v-select  class="custom-vue-select" :options="territories" label="name" :reduce="t => t.id" v-model="item.territory" placeholder="Select a territory"></v-select>
            </div>

        </form>
    </b-modal>

    <!-- Edit Item -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Route" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <b-form-group label="Route Name" label-for="name-input" invalid-feedback="Item is required">
                <b-form-input id="name-input" v-model="edit_item.name" placeholder="Enter Route Name"></b-form-input>
            </b-form-group>
            <div class="form-group">
                <label>Territory</label>
                <v-select  class="custom-vue-select" :options="territories" label="name" :reduce="t => t.id" v-model="edit_item.territory" placeholder="Select a territory"></v-select>
            </div>

        </form>
    </b-modal>

    <!-- Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this route?</div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
export default {
    components: {
        'v-select': vSelect
    },
    data() {
        return {
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'name',
                    label: 'Name',
                    sortable: true
                },
                {
                    key: 'territory_name',
                    label: 'Territory',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],

            item: {
                name: '',
                territory: null,
            },

            edit_item: {
                id: null,
                name: '',
                territory: null,
            },

            initialLoad: true,
            filter: null,
            delete_value: null,

            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100]
        };
    },

    computed: {
        ...mapState({
            items: state => state.territory.route,
            loading: state => state.territory.routeLoading,
            error: state => state.territory.routeError,
            territories: state => state.territory.territory,
        })
    },

    mounted() {

        this.$store.dispatch("territory/fetchRoute").then((response) => {
            this.totalRows = response.data.length;
        });
        this.$store.dispatch("territory/fetchTerritory")
        // if (!this.$route.query.page || !this.$route.query.perPage) {
        //     this.$router.replace({
        //         path: this.$route.path,
        //         query: {
        //             page: this.currentPage,
        //             perPage: this.perPage,
        //         },
        //     });
        //     this.$store.dispatch("item/fetchItemWithPagination", {
        //         perPage: this.perPage,
        //         currentPage: this.currentPage,
        //         search_term: this.filter
        //     }).then(() => {
        //         this.totalRows = this.items.length;
        //         this.initialLoad = false;
        //     });
        // } else {
        //     this.$router.replace({
        //         path: this.$route.path,
        //         query: {
        //             page: this.$route.query.page,
        //             perPage: this.$route.query.perPage,
        //         },
        //     });
        //     this.currentPage = this.$route.query.page
        //     this.perPage = this.$route.query.perPage
        //     this.$store.dispatch("item/fetchItemWithPagination", {
        //         currentPage: this.$route.query.page,
        //         perPage: this.$route.query.perPage,
        //         search_term: this.filter
        //     }).then(() => {
        //         this.totalRows = this.items.length;
        //         this.initialLoad = false;
        //     });
        // }
    },

    watch: {
        // currentPage(newCurrentPage) {
        //     if (!this.initialLoad) {
        //         this.$router.replace({
        //             path: '/finance-and-accounts/finance/items/list',
        //             query: {
        //                 page: newCurrentPage,
        //                 perPage: this.perPage,

        //             },
        //         });
        //         this.currentPage = newCurrentPage
        //         this.$store.dispatch("item/fetchItemWithPagination", {
        //             perPage: this.perPage,
        //             currentPage: newCurrentPage,
        //             search_term: this.filter
        //         }).then(() => {
        //             this.totalRows = this.items.length;
        //         });
        //     }
        // },

        // perPage(newperPage) {
        //     if (!this.initialLoad) {
        //         this.$router.replace({
        //             path: '/finance-and-accounts/finance/items/list',
        //             query: {
        //                 page: this.currentPage,
        //                 perPage: newperPage
        //             },
        //         });
        //         this.perPage = newperPage
        //         this.$store.dispatch("item/fetchItemWithPagination", {
        //             perPage: newperPage,
        //             currentPage: this.currentPage,
        //             search_term: this.filter
        //         }).then(() => {
        //             this.totalRows = this.items.length;
        //         });
        //     }
        // },

        // filter(newVal, oldVal) {
        //     this.$store.dispatch("route/fetchRoute", {
        //         perPage: this.perPage,
        //         currentPage: 1,
        //         search_term: this.filter
        //     }).then(() => {
        //         this.totalRows = this.items.length;
        //     });
        // }
    },

    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.item.name = ''

        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("territory/addRoute", {
                item: this.item,

            }).then(response => {
                if (response.code == 201) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.item.name = ''
                    this.item.territory = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editItem(item) {
            this.edit_item.id = item.id
            this.edit_item.name = item.name
            this.edit_item.territory = item.territory.id

        },

        handleEditSubmit() {
            this.$store.dispatch("territory/updateRoute", {
                item: this.edit_item,

            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.edit_item.name = ""
                    this.edit_item.id = null
                    this.edit_item.territory = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },

        deleteItem(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("territory/deleteRoute", {
                item: this.delete_value,

            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
